import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import IconButton from '@widget/buttons/IconButton';
import MediaThumb from './MediaThumb';
/**
 * @export
 * A media preview: the picture fitted on a plain stage, with a bar of facts at the bottom.
 * The picker shows every source this way.
 *
 * @example
 * ```tsx
 * <MediaStage value={url} info={<><b>lobby.png</b> · PNG · 800 × 800 px</>} />
 * ```
 *
 * @category Inputs/Pickers
 */
const MediaStage = ({ value, type, name, info, actions, empty, onClose, className }) => {
    return _jsxs("div", { className: classNames('uxpcore_mediastage', { 'uxpcore_mediastage--empty': !value, 'uxpcore_mediastage--bar': value && (info || actions) }, className), children: [value
                ? _jsx("div", { className: "uxpcore_mediastage__media", children: _jsx(MediaThumb, { value: value, type: type, name: name, fit: "contain" }) })
                : empty && _jsx("div", { className: "uxpcore_mediastage__empty", children: empty }), onClose && _jsx(IconButton, { className: "uxpcore_mediastage__close", type: "close", variant: "secondary", size: "small", onClick: onClose }), value && (info || actions) && _jsxs("div", { className: "uxpcore_mediastage__bar", children: [_jsx("span", { className: "uxpcore_mediastage__info", children: info }), actions && _jsx("span", { className: "uxpcore_mediastage__actions", children: actions })] })] });
};
export default MediaStage;
